import { BrowserRouter as Router } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useContext } from "react";

import App from "../App";
import AppProvider from "./app-context/AppProvider";
import ModalProvider from "./modal-context/ModalProvider";
import SocketProvider from "./socket-provider/SocketProvider";
import { WagmiProvider } from 'wagmi';
import { walletConnectConfig } from '../config/WalletConnect';
import { AppContext } from "./app-context/AppContext";
import { ModalContext } from "./modal-context/ModalContext";
import { SocketContext } from "./socket-provider/ScoketContext";

// Initialize i18n
import '../i18n';

export const queryClient = new QueryClient();

const useApp = () => {
  const value = useContext(AppContext);
  if (import.meta.env.NODE_ENV !== "production") {
    if (!value) {
      throw new Error("useApp must be wrapped in a <AppProvider />");
    }
  }
  return value;
};

const useModal = () => {
  const value = useContext(ModalContext);
  if (import.meta.env.NODE_ENV !== "production") {
    if (!value) {
      throw new Error("useModal must be wrapped in a <ModalProvider />");
    }
  }
  return value;
};

const useSocket = () => {
  const value = useContext(SocketContext);
  if (import.meta.env.NODE_ENV !== "production") {
    if (!value) {
      throw new Error("useSocket must be used within a <SocketProvider />");
    }
  }
  return value;
};

export const Providers = () => {
  return (
    <>
      <WagmiProvider config={walletConnectConfig}>
        <QueryClientProvider client={queryClient}>
          <AppProvider>
            <ModalProvider>
              <SocketProvider>
                <Router>
                  <App />
                </Router>
              </SocketProvider>
            </ModalProvider>
          </AppProvider>
        </QueryClientProvider>
      </WagmiProvider>
    </>
  );
};

export { useApp, useModal, useSocket };